export const oidcConfig = {
  authority: window.env.REACT_APP_OIDC_AUTHORITY,
  client_id: window.env.REACT_APP_OIDC_CLIENT_ID,
  redirect_uri: window.env.PUBLIC_URL,
  post_logout_redirect_uri: window.env.PUBLIC_URL,
  automaticSilentRenew: true,
  silent_redirect_uri: window.env.PUBLIC_URL,
  response_type: "code",
  scope: "openid profile role email licnapi company phone addresses",
  filterProtocolClaims: true,
  loadUserInfo: true,
};
